import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ajaxGetScsDictItems } from '@/api/api';
export default {
  name: 'ScsMultiSelectTag',
  props: {
    dictCode: String,
    placeholder: String,
    disabled: Boolean,
    value: String,
    type: String,
    options: Array
  },
  data: function data() {
    return {
      dictOptions: [],
      tagType: "",
      arrayValue: !this.value ? [] : this.value.split(",")
    };
  },
  created: function created() {
    if (!this.type || this.type === "list_multi") {
      this.tagType = "select";
    } else {
      this.tagType = this.type;
    } //获取字典数据


    this.initDictData();
  },
  watch: {
    options: function options(val) {
      this.setCurrentDictOptions(val);
    },
    value: function value(val) {
      if (!val) {
        this.arrayValue = [];
      } else {
        this.arrayValue = this.value.split(",");
      }
    }
  },
  methods: {
    initDictData: function initDictData() {
      var _this = this;

      if (this.options && this.options.length > 0) {
        this.dictOptions = _toConsumableArray(this.options);
      } else {
        //根据字典Code, 初始化字典数组
        ajaxGetScsDictItems(this.dictCode, null).then(function (res) {
          if (res.success) {
            _this.dictOptions = res.result;
          }
        });
      }
    },
    onChange: function onChange(selectedValue) {
      this.$emit('change', selectedValue.join(","));
    },
    setCurrentDictOptions: function setCurrentDictOptions(dictOptions) {
      this.dictOptions = dictOptions;
    },
    getCurrentDictOptions: function getCurrentDictOptions() {
      return this.dictOptions;
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
};